<template>
  <div class="charts-pie">
    <el-row type="flex" class="charts-pie-info" v-if="type == 'Chart2'">
      <el-col>
        <div
          class="charts-pie-info__item"
          style="margin-top: -22px"
          v-for="(item, index) in sdata.slice(-1).reverse()"
          :key="index"
        >
          <h4>
            {{ item.name }}<br />
            <b :style="getLeftColor(index)"
              >{{ getPercentage(item.value) }}％</b
            >
          </h4>
          <p :style="getLeftColor(index)">{{ item.value }}</p>
        </div>
      </el-col>
      <el-col>
        <div
          class="charts-pie-info__item"
          style="margin-top: -22px"
          v-for="(item, index) in sdata.slice(0, 1)"
          :key="index"
        >
          <h4>
            {{ item.name }}<br />
            <b :style="getRightColor(index)"
              >{{ getPercentage(item.value) }}％</b
            >
          </h4>
          <p :style="getRightColor(index)">{{ item.value }}</p>
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" class="charts-pie-info" v-if="type == 'Chart1'">
      <el-col>
        <div
          class="charts-pie-info__item"
          style="margin-top: -22px"
          v-for="(item, index) in sdata.slice(-1).reverse()"
          :key="index"
        >
          <h4>
            {{ item.name }}<br />
            <b :style="getLeftColor2(index)"
              >{{ getPercentage(item.value) }}％</b
            >
          </h4>
          <p :style="getLeftColor2(index)">{{ item.value }}</p>
        </div>
      </el-col>
      <el-col>
        <div
          class="charts-pie-info__item"
          style="margin-top: -22px"
          v-for="(item, index) in sdata.slice(0, 2)"
          :key="index"
        >
          <h4>
            {{ item.name }}<br />
            <b :style="getRightColor2(index)"
              >{{ getPercentage(item.value) }}％</b
            >
          </h4>
          <p :style="getRightColor2(index)">{{ item.value }}</p>
        </div>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      class="charts-pie-info"
      v-if="type == 'Chart3' || type == 'Chart4'"
    >
      <ul class="noticeList" :class="type == 'Chart4' ? 'default' : ''">
        <li v-for="(item, index) in sdata" :key="index">
          <div>
            <p>
              <span
                v-if="type == 'Chart3'"
                class="color"
                :style="getRightColor3(index)"
                >■</span
              >
              <span
                v-if="type == 'Chart4'"
                class="color"
                :style="getLeftColor3(index)"
                >■</span
              >
              <span class="colorSpan">{{ item.name }}</span>
            </p>
            <span>{{ item.value }}</span>
            <em v-if="sumCount">{{
              Number(((item.value / sumCount) * 100).toFixed(2)) + "%"
            }}</em>
          </div>

          <!--  <span>
	        <em v-if="sumCount">{{Number(((item.value / sumCount) * 100).toFixed(2))+'%'}}</em>
	      </span> -->
        </li>
      </ul>
    </el-row>
    <div class="line-box" v-if="type == 'Chart5' && sdata.length == 6">
      <div class="left-line" v-if="type == 'Chart5'">
        <!-- <p><span>22台</span></p>
        <p><span>12台</span></p>
        <p><span>18台</span></p> -->
        <p></p>
        <p></p>
        <p></p>
      </div>
      <div class="right-line" v-if="type == 'Chart5'">
        <!-- <p><span>87台</span></p>
        <p><span>20台</span></p>
        <p><span>10台</span></p> -->
        <p></p>
        <p></p>
        <p></p>
      </div>
    </div>
    <div class="charts-pie-chart__canvas" :id="id"></div>
    <!-- <div v-if="type=='Chart3' || type=='Chart4'" class="chart-circle"></div> -->
  </div>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "chartsPie",
  mixins: [global],
  props: {
    data: Array,
    id: String,
    colorList: Array,
    type: String,
    sumCount: Number,
  },
  data() {
    return {
      myChart: null,
      sdata: [
        { value: 335, name: "类型1" },
        { value: 310, name: "类型2" },
        { value: 234, name: "类型3" },
        { value: 135, name: "类型4" },
      ],
    };
  },
  methods: {
    getRightColor(index) {
      return "color:" + this.chartConfig.colorList[index];
    },
    getLeftColor(index) {
      const colorList = this.colorList
        ? this.colorList
        : this.chartConfig.colorList;
      return "color:" + colorList[colorList.length - 1 - index];
    },
    getRightColor2(index) {
      return "color:" + this.chartConfig.colorList2[index];
    },
    getLeftColor2(index) {
      const colorList = this.colorList
        ? this.colorList
        : this.chartConfig.colorList2;
      return "color:" + colorList[colorList.length - 1 - index];
    },
    getRightColor3(index) {
      return "color:" + this.chartConfig.screenColorList2[index];
    },
    getLeftColor3(index) {
      return "color:" + this.chartConfig.screenColorList[index];
    },
    setId: function () {
      return "charts-pie-chart__" + this.index;
    },
    SetEchart() {
      var id = this.id;
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      var option = {
        color: this.colorList
          ? this.colorList
          : this.sdata.length != 3
          ? this.chartConfig.colorList
          : this.chartConfig.colorList2,
        series: [
          {
            name: "外边",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            center: ["50%", "50%"],
            radius: ["0%", "66%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#e3e7ec",
                  },
                },
              },
            ],
          },
          {
            name: "外边框",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            center: ["50%", "50%"],
            radius: ["66%", "66%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#c9caca",
                    borderWidth: 1,
                    borderColor: "#c9caca",
                  },
                },
              },
            ],
          },
          {
            name: "类型占比",
            type: "pie",
            radius: ["26%", "60%"],
            // roseType: "radius",
            avoidLabelOverlap: false,
            // silent: true,
            label: {
              normal: {
                show: false,
                // padding: [0, 0, 0, 3],
                // formatter: "{b}类型",
                // postion: "inner"
              },
            },

            grid: {
              // 控制图的大小，调整下面这些值就可以，
              x: 40,
              x2: 100,
              y2: 150, // y2可以控制 X轴跟Zoom控件之间的间隔，避免以为倾斜后造成 label重叠到zoom上
            },
            itemStyle: {
              // borderColor: "#fff",
              // borderWidth: 4
            },
            data: this.sdata,
          },
        ],
      };
      this.myChart.setOption(option);
    },
    SetEchart2() {
      var id = this.id;
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      var option = {
        color: this.colorList
          ? this.colorList
          : this.sdata.length != 3
          ? this.chartConfig.screenColorList
          : this.chartConfig.screenColorList2,
        series: [
          {
            name: "外边框",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            center: ["50%", "50%"],
            radius: ["66%", "66%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#c9caca",
                    borderWidth: 1,
                    borderColor: "#c9caca",
                    opacity: 0.3,
                  },
                },
              },
            ],
          },
          {
            name: "内填充",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            center: ["50%", "50%"],
            radius: ["30%", "40%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#c9caca",
                    // borderWidth: 6,
                    // borderColor: "#c9caca",
                    opacity: 0.1,
                  },
                },
              },
            ],
          },
          {
            name: "类型占比",
            type: "pie",
            radius: ["53%", "60%"],
            // roseType: "radius",
            avoidLabelOverlap: false,
            // silent: true,
            label: {
              normal: {
                show: false,
                // padding: [0, 0, 0, 3],
                // formatter: "{b}类型",
                // postion: "inner"
              },
            },

            grid: {
              // 控制图的大小，调整下面这些值就可以，
              x: 40,
              x2: 100,
              y2: 150, // y2可以控制 X轴跟Zoom控件之间的间隔，避免以为倾斜后造成 label重叠到zoom上
            },
            itemStyle: {
              // borderColor: "#fff",
              // borderWidth: 4
            },
            data: this.sdata,
          },
        ],
        graphic: {
          // 添加原生图形元素组件
          elements: [
            {
              type: "text", // 组件类型
              zlevel: 10,
              left: "center", //定位
              top: "43%", // 定位
              style: {
                // 样式
                text: this.sumCount, //文字
                fontSize: 12, //文字大小
                textAlign: "center", //定位
                width: "auto",
                height: 11,
                fill: "#F7FDFD", // 字体颜色
                shadowColor: "0px 1px 1px rgba(24, 124, 216, 0.75)",
                font: 'bold 12px "Alibaba PuHuiTi"',
              },
            },
            {
              type: "text",
              zlevel: 10,
              left: "center",
              top: "55%",
              style: {
                text: "合计",
                fontSize: 9,
                textAlign: "center",
                width: "auto",
                height: 9,
                fill: "#E1E7ED",
                font: '400 9px "Alibaba PuHuiTi"',
              },
            },
          ],
        },
      };
      this.myChart.setOption(option);
    },
    SetEchart5() {
      var id = this.id;
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      var option = {
        color: [
          "#489EF5",
          "#7C8491",
          "#4A4B4C",
          "#8CCF73",
          "#EFAB52",
          "#EE4A61",
        ],
        series: [
          {
            name: "外边",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            center: ["50%", "50%"],
            radius: ["0%", "66%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#f6f7fb",
                  },
                },
              },
            ],
          },
          {
            name: "内边",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            zlevel: 9,
            center: ["50%", "50%"],
            radius: ["26%", "32%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "rgba(255,255,255,0.2)",
                  },
                },
              },
            ],
          },
          {
            name: "外边框",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            silent: true,
            center: ["50%", "50%"],
            radius: ["66%", "66%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#c9caca",
                    borderWidth: 1,
                    borderColor: "#c9caca",
                  },
                },
              },
            ],
          },
          {
            name: "类型占比",
            type: "pie",
            radius: ["26%", "60%"],
            // roseType: "radius",
            avoidLabelOverlap: false,
            // silent: true,
            label: {
              normal: {
                show: false,
                // padding: [0, 0, 0, 3],
                // formatter: "{b}类型",
                // postion: "inner"
              },
            },

            grid: {
              // 控制图的大小，调整下面这些值就可以，
              x: 40,
              x2: 100,
              y2: 150, // y2可以控制 X轴跟Zoom控件之间的间隔，避免以为倾斜后造成 label重叠到zoom上
            },
            itemStyle: {
              // borderColor: "#fff",
              // borderWidth: 4
            },
            data: this.sdata,
          },
        ],
      };
      this.myChart.setOption(option);
    },
    selfAdaption() {
      // setTimeout(() => {
      //   window.addEventListener("resize", () => {
      //     this.myChart.resize();
      //   });
      // }, 20);
    },
    getPercentage(val) {
      if (val == 0) {
        return 0;
      }
      var sum = this.sdata.reduce(function (prev, cur) {
        return cur.value + prev;
      }, 0);
      return ((val / sum) * 100).toFixed(2);
    },
    initChart() {
      if (this.type == "Chart1" || this.type == "Chart2") {
        this.SetEchart();
      } else if (this.type == "Chart5") {
        this.SetEchart5();
      } else {
        this.SetEchart2();
      }
      this.selfAdaption();
    },
  },
  computed: {},
  watch: {
    data(val) {
      if (val) {
        this.sdata = val;
        if (this.type == "Chart1" || this.type == "Chart2") {
          this.SetEchart();
        } else {
          this.SetEchart2();
        }
        this.selfAdaption();
      }
    },
  },
  mounted() {
    if (this.data) {
      this.sdata = this.data;
    }
    if (this.type == "Chart1" || this.type == "Chart2") {
      this.SetEchart();
    } else {
      this.SetEchart2();
    }

    this.selfAdaption();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.charts-pie {
  width: 50%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  @media screen and (max-width: 1600px) {
    // width: 60%;
    width: 223px;
  }
  &-chart {
    &__canvas {
      width: 100%;
      height: 100%;
    }
  }
  &-info {
    position: absolute;
    width: 90%;
    left: 5%;
    height: 100%;
    // padding: 0 30px;
    font-size: $--font-size-small;
    &__item {
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:last-child {
        text-align: right;
      }
    }
    h4 {
      color: darken($--color-text-regular, 10%);
      b {
        font-size: 19px;
        font-weight: normal;
        color: $--color-text-primary;
        // margin-left: 5px;
      }
    }
    p {
      line-height: 2.2;
      margin-top: 2px;
      border-top: 1px solid $--border-color-base;
      color: $--color-primary;
    }
  }
  .left-line {
    position: absolute;
    // top: 88px;
    // left: -188px;
    margin-top: 27px;
    top: 50%;
    transform: translateY(-50%);
    left: -75%;
    width: 100%;
  }
  .right-line {
    position: absolute;
    // top: 88px;
    // right: -188px;
    margin-top: 27px;
    top: 50%;
    transform: translateY(-50%);
    right: -75%;
    width: 100%;
  }
  .left-line,
  .right-line {
    p {
      width: 100%;
      height: 1px;
      margin-bottom: 54px;
      position: relative;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .left-line p {
    // span {
    //   position: absolute;
    //   right: 18px;
    //   top: -22px;
    // }

    &:nth-child(1) {
      background: url(../assets/img/index/line_right_bottom.png) no-repeat;
      height: 29px;
      background-size: contain;
      background-position: center right;
      span {
        color: $--color-primary;
      }
    }
    &:nth-child(2) {
      background: url(../assets/img/index/line.png) no-repeat;
      background-size: contain;
      background-position: center right;
      span {
        color: $--color-warning;
      }
    }
    &:nth-child(3) {
      background: url(../assets/img/index/line_right_top.png) no-repeat;
      height: 29px;
      background-size: contain;
      background-position: center right;

      span {
        color: $--color-success;
        top: -3px;
      }
    }
  }
  .right-line p {
    // span {
    //   position: absolute;
    //   left: 10px;
    //   top: -22px;
    // }
    &:nth-child(1) {
      background: url(../assets/img/index/line_left_bottom.png) no-repeat;
      height: 29px;
      background-size: contain;
      span {
        color: $--color-calm;
      }
    }
    &:nth-child(2) {
      background: url(../assets/img/index/line.png) no-repeat;
      background-size: contain;
      span {
        color: $--color-info;
      }
    }
    &:nth-child(3) {
      background: url(../assets/img/index/line_left_top.png) no-repeat;
      height: 29px;
      background-size: contain;
      span {
        color: $--color-black;
        top: -3px;
      }
    }
  }
}
.noticeList {
  position: absolute;
  width: 55%;
  right: 0;
  top: 46% !important;
  transform: translate(0%, -50%) !important;
  li {
    padding: 0px !important;
    margin-bottom: 0.5vh;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #1676cf;
    > div {
      flex: 1;
      > span {
        font-size: 1.1vmin;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #e1e7ed;
        text-shadow: 0px 1px 1px rgba(24, 124, 216, 0.75);
        background: linear-gradient(0deg, #ffffff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: #ffffff;
      }
    }
    p {
      border-top: none;
      font-size: 1.1vmin;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #e1e7ed;
      line-height: 1.4;
      width: 100%;
      height: 1.8vh;
      margin-bottom: 10px;
      .color {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-right: 5px;
        border: 1px solid #1676cf;
        // text-align: center;
        line-height: 5px;
        vertical-align: middle;
        text-align: center;
      }
      .colorSpan {
        vertical-align: middle;
      }
    }
    em {
      font-size: 1.5vmin;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #f7fdfd;
      text-shadow: 0px 1px 1px rgba(24, 124, 216, 0.75);
      background: linear-gradient(0deg, #ffffff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: #ffffff;
      // margin-bottom: -2vh;
      display: inline-block;
      float: right;
    }
  }
}
.default {
  li {
    p {
      margin-bottom: 4px;
    }
  }
}
.chart-circle {
  width: 10vh;
  height: 10vh;
  position: absolute;
  border-radius: 50%;
  border: 1px solid red;
}
/deep/ .charts-pie-chart__canvas {
  > div {
    margin: 0 auto !important;
  }
}
@media screen and (max-width: $--lg) {
  .charts-pie-info {
    font-size: $--font-size-extra-small;
  }
}
.line-box {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
